import { render, staticRenderFns } from "./chooseEmployeeDialog.vue?vue&type=template&id=60d4c2b5"
import script from "./chooseEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./chooseEmployeeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports